import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=6ca1c204&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"
import style0 from "./UserView.vue?vue&type=style&index=0&id=6ca1c204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1c204",
  null
  
)

export default component.exports